module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Regular.abe60269.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/SFProDisplay-Regular.woff2
// module id = 331
// module chunks = 1